<template>
    <div 
        class="permission-toggle" 
        :class="{
            'active': isActive,
            'disabled': isDisabled
        }"
        @click="toggle"
    >
        <span class="material-icons">check</span>
    </div>
</template>

<script>
export default {
    name: 'PermissionToggle',
    props: {
        isActive: {
            type: Boolean,
            default: false
        },
        isDisabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        toggle() {
            if (!this.isDisabled) {
                this.$emit('toggle');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.permission-toggle {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-right: 0.5rem;
    user-select: none;

    span {
        font-size: 14px;
        color: transparent;
        transition: all 0.2s ease;
    }

    &:hover {
        border-color: #bbdefb;
        background-color: #f5f9ff;

        span {
            color: #90caf9;
        }
    }

    &.active {
        border-color: #4caf50;
        background-color: #fff;

        span {
            color: #4caf50;
        }

        &:hover {
            background-color: #f1f8f1;

            span {
                color: #388e3c;
            }
        }
    }

    &.disabled {
        opacity: 0.6;
        background-color: #fafafa;
        cursor: not-allowed;
        border-color: #e0e0e0;

        &:hover {
            background-color: #fafafa;
            border-color: #e0e0e0;

            span {
                color: transparent;
            }
        }
    }
}
</style> 